module.exports = {

    init: function () {
        $('a.phone').click(function () {
            window.location.href = 'tel:' + $('button#phone').text();
        })

        $('a.contact').click(function () {
            $([document.documentElement, document.body]).animate({
                scrollTop: $("#contact-form-text").offset().top
            }, 1000);
        })
    }

};